import {
  DollarCircleFillIcon,
  HotWalletIcon,
  PortfolioFillIcon,
} from '@infinex/ui-icons';
import {
  Button,
  Content,
  DismissButton,
  Footer,
  Image,
  Surface,
  XStack,
  YStack,
} from '@infinex/ui/components';

import { LegalInfo } from './LegalInfo';

import { getCloudinaryImageUrl } from '../../../utils/cloudinary/getCloudinaryImageUrl';
import { AccentGradientOverlay } from '../../ui/AccentGradientOverlay';

export function GasOnboarding({
  handleDismiss,
}: {
  handleDismiss: () => void;
}) {
  return (
    <>
      <AccentGradientOverlay />

      <DismissButton className="absolute top-4 right-4 z-20" />

      <Image
        className="pointer-events-none z-10"
        src={getCloudinaryImageUrl('gas-onboarding-bg_zmtdvb')}
      />

      <Content>
        <YStack gap="24px">
          <YStack align="center" gap="8px">
            <h3 className="text-2xl font-semibold">Your Gas Account</h3>

            <p className="text-sm font-medium">
              Pay for all your network costs from one place.
            </p>
          </YStack>

          <Surface
            className="text-xs font-medium"
            rounded="medium"
            padding="16px"
          >
            <YStack gap="16px" align="left">
              <XStack align="center" gap="16px">
                <IconContainer>
                  <PortfolioFillIcon size="2xsmall" />
                </IconContainer>

                <span>Top up with any token in your portfolio</span>
              </XStack>

              <XStack align="center" gap="16px">
                <IconContainer>
                  <DollarCircleFillIcon size="2xsmall" />
                </IconContainer>

                <span>Never worry about native gas again</span>
              </XStack>

              <XStack align="center" gap="16px">
                <IconContainer>
                  <HotWalletIcon size="2xsmall" />
                </IconContainer>

                <span>Works everywhere with the Infinex Extension</span>
              </XStack>
            </YStack>
          </Surface>

          <LegalInfo />

          <Footer className="grid">
            <Button prominence="high" onPress={handleDismiss}>
              Got it
            </Button>
          </Footer>
        </YStack>
      </Content>
    </>
  );
}

function IconContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-fill flex size-7 items-center justify-center rounded-lg">
      {children}
    </div>
  );
}
